<template>
  <div class="home">
    <a-row :gutter="[16, 16]">
      <a-col :lg="24" :md="24" :sm="24" :xl="12" :xs="24" :xxl="8">
        <a-card :title="this.account.accountType === 'PERSONAL' ? 'Profil użytkownika' : 'Profil organizacji'"
                style="margin-bottom: 16px">
          <a-row :gutter="[16, 16]" align="middle" type="flex">
            <a-col>
              <a-avatar :icon="computedAvatar" :size="61" style="backgroundColor: #84ccff"/>
            </a-col>
            <a-col>
              <strong>{{ account.name }} {{
                  account.surname
                }}</strong><br/>
              <small>{{ computedTitle }}&nbsp;&bull;&nbsp;{{ computedType }}</small>
            </a-col>
            <a-col :span="24" style="text-align: right; margin-top: 8px">
              <a-button key="3" style="margin-left: 8px;" @click="changePasswordModal = true;">
                Zmień hasło
              </a-button>
              <a-button key="4" style="margin-left: 8px;" type="primary" @click="logout()">
                Wyloguj
              </a-button>
            </a-col>
          </a-row>
        </a-card>
        <a-card>
          <DeviceInfo/>
        </a-card>
      </a-col>

      <a-col :lg="24" :md="24" :sm="24" :xl="12" :xs="24" :xxl="16">
        <a-card :active-tab-key="activeTab" :tab-list="tabList" @tabChange="onTabChange($event)">
          <span slot="customRender">
              <a-badge :count="0" :overflow-count="9">
                  <span style="margin-right: 0">Zgłoszenia</span>
              </a-badge>
          </span>
          <div v-if="activeTab === 'devices'">
            <a-row v-if="computedSession && computedSession.isLocalConnection && !computedSession.hasAccount" :gutter="[16, 16]">
              <a-col :span="24">
                <a-card style="background-color: #e6f7ff; border: 1px solid #91d5ff; text-align: center">
                  <p style="font-weight: 500">Urządzenie którego właśnie używasz może zostać dodane do Twojego konta użytkownika.</p>
                  <a-button type="primary" @click="addDeviceModal = true">Dodaj to urządzenie</a-button>
                </a-card>
              </a-col>
            </a-row>
            <a-row v-if="this.account.accountType === 'SERVICE'" :gutter="[16, 16]">
              <a-page-header
                  sub-title="Konto organizacji umożliwia dodawanie urządzeń w trybie przyśpieszonym.">
                <template #extra>
                  <a-button icon="plus" type="primary">Dodaj nowe urządzenie</a-button>
                </template>
              </a-page-header>
            </a-row>
            <a-divider v-if="this.account.accountType === 'COMMERCIAL'"/>
            <a-row v-if="account.devices && account.devices.length > 0" :gutter="[16, 16]">
              <a-col v-for="device in account.devices ? account.devices.filter((d) => d.enabled) : []"
                     :key="device.deviceId"
                     :span="24">
                <SingleDevice :debugMode="debugMode" :device="device" @updated="getAccount"/>
              </a-col>
            </a-row>
            <a-row v-if="account.devices && account.devices.length > 0" :gutter="[16, 16]">
              <a-col v-for="device in account.devices ? account.devices.filter((d) => !d.enabled) : []"
                     :key="device.deviceId"
                     :span="24">
                <SingleDevice :debugMode="debugMode" :device="device" @updated="getAccount"/>
              </a-col>
            </a-row>
            <a-row v-if="!account.devices || account.devices.length <= 0" :gutter="[16, 16]">
              <a-col>
                <a-empty style="margin-top: 3em;">
                  <span slot="description">
                    <strong>Nie posiadasz ani jednego urządzenia!</strong>
                    <p>Możesz dodać urządzenie na którym właśnie jesteś zalogowany(na).</p>
                  </span>
                  <a-button type="primary" @click="addDeviceModal = true">Dodaj to urządzenie</a-button>
                </a-empty>
              </a-col>
            </a-row>
          </div>
          <div v-if="activeTab === 'issues'">
            <a-empty>
              <span slot="description"> Brak aktywnych zgłoszeń </span>
              <a-button type="primary">
                Utwórz zgłoszenie
              </a-button>
            </a-empty>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <SetPasswordModal :enabled="setPasswordModal" @close="setPasswordModal = false"/>
    <ChangePasswordModal :enabled="changePasswordModal" @close="changePasswordModal = false"/>
    <AddDeviceModal :enabled="addDeviceModal" @close="closeAddDeviceModal"/>
  </div>
</template>

<script>
import httpClient from "../utils/httpClient";
import SingleDevice from "../components/network/SingleDevice.vue";
import DeviceInfo from "@/components/network/DeviceInfo";
import AddDeviceModal from "@/components/account/AddDeviceModal.vue";
import SetPasswordModal from "../components/account/SetPasswordModal.vue";
import ChangePasswordModal from "../components/account/ChangePasswordModal.vue";

export default {
  name: "Account",
  components: {
    DeviceInfo,
    SingleDevice,
    AddDeviceModal,
    SetPasswordModal,
    ChangePasswordModal
  },
  data() {
    return {
      account: {},
      debugMode: false,
      activeTab: "devices",
      tabList: [
        {
          key: "devices",
          tab: "Twoje urządzenia",
        },
        // {
        //   key: "issues",
        //   scopedSlots: {tab: 'customRender'},
        // }
      ],
      changePasswordModal: false,
      setPasswordModal: false,
      addDeviceModal: false,
    };
  },
  computed: {
    computedAvatar: function () {
      if (this.account.accountType === 'PERSONAL') {
        return 'user'
      }
      if (this.account.accountType === 'COMMERCIAL') {
        return 'bank'
      }
      if (this.account.accountType === 'SERVICE') {
        return 'deployment-unit'
      } else {
        return 'user'
      }
    },
    computedTitle: function () {
      if (this.account.accountType === 'PERSONAL') {
        return 'Konto użytkownika'
      }
      if (this.account.accountType === 'COMMERCIAL') {
        return 'Konto organizacji'
      }
      if (this.account.accountType === 'SERVICE') {
        return 'Konto serwisowe'
      } else {
        return 'Konto domyślne'
      }
    },
    computedType: function () {
      if (this.account.accountStatus === 'INACTIVE') {
        return 'Nieaktywne'
      }
      if (this.account.accountStatus === 'WAITING') {
        return 'Oczekujące na aktywację'
      }
      if (this.account.accountStatus === 'ACTIVE') {
        return 'Aktywne'
      }
      if (this.account.accountStatus === 'PROBLEM') {
        return 'Problem z kontem'
      }
      if (this.account.accountStatus === 'BANNED') {
        return 'Zablokowane'
      }
      if (this.account.accountStatus === 'DEPRECATED') {
        return 'Konto wygasło'
      } else {
        return 'Stan nieznany'
      }
    },
    computedSession: function () {
      return this.$store.getters.getUserConnectionDetails;
    },
  },
  mounted() {
    this.$emit("loadedView");

    this.getAccount()
    window.addEventListener('keydown', this.checkKeyCombination);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.checkKeyCombination);
  },
  methods: {
    getAccount() {
      httpClient.get("/identity/me").then((response) => {
        this.account = response
        if (this.account.loginType !== 'PASSWORD') {
          this.setPasswordModal = true
        }
      }).catch((error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          this.$router.push({name: "Home"})
        }
      })
    },
    checkKeyCombination(event) {
      if (event.ctrlKey && event.shiftKey && event.key === 'D') {
        this.debugMode = !this.debugMode
        console.log("Debug mode: ", this.debugMode)
        event.preventDefault();
      }
    },
    logout() {
      window.location.href = "/api/identity/logout?next=/account/logout"
    },
    closeAddDeviceModal() {
      this.addDeviceModal = false
      window.location.reload()
    },
    onTabChange(key) {
      this.activeTab = key
    },
  }
};
</script>
